import {
	LuIcon,
	Menu,
	type MenuClickTriggerProps,
	type MenuMultiSelectGroupProps,
	type MenuRootProps,
	type MenuVariantProps,
} from "@overmap-ai/blocks"
import { memo, type ReactElement } from "react"

import { ASSET_TIMELINE_ITEM_TYPES } from "../../constants"
import { AssetTimelineItemType } from "../../enums/assets"
import { assetTimelineItemTypeData } from "../../mappings/assets"
import { MultiSelectItemTemplate, SelectAllItemTemplate } from "../MenuGroups/constants"

interface AssetTimelineItemTypeMultiSelectDropdownProps
	extends
		MenuRootProps,
		MenuMultiSelectGroupProps<AssetTimelineItemType>,
		MenuVariantProps,
		Omit<MenuClickTriggerProps, "children" | "ref"> {
	children: ReactElement
}

export const AssetTimelineItemTypeMultiSelectDropdown = memo<AssetTimelineItemTypeMultiSelectDropdownProps>((props) => {
	const { children, disabled, variant, size, accentColor, values, onValuesChange, defaultValues, ...rest } = props

	return (
		<Menu.Root {...rest}>
			<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
			<Menu.Content variant={variant} size={size} accentColor={accentColor}>
				<Menu.MultiSelectGroup<AssetTimelineItemType>
					defaultValues={defaultValues}
					values={values}
					onValuesChange={onValuesChange}
				>
					<SelectAllItemTemplate>Select all</SelectAllItemTemplate>
					{ASSET_TIMELINE_ITEM_TYPES.map((type) => {
						const { icon, label } = assetTimelineItemTypeData[type]

						return (
							<MultiSelectItemTemplate<AssetTimelineItemType> key={type} value={type}>
								<LuIcon icon={icon} />
								{label}
							</MultiSelectItemTemplate>
						)
					})}
				</Menu.MultiSelectGroup>
			</Menu.Content>
		</Menu.Root>
	)
})
AssetTimelineItemTypeMultiSelectDropdown.displayName = "AssetTimelineItemTypeMultiSelectDropdown"
